export default __webpack_public_path__ + "static/media/feed6.d3e0dcd9.jpg";